import { render, staticRenderFns } from "./shadowTxtComment.vue?vue&type=template&id=7950ff9c&scoped=true"
import script from "./shadowTxtComment.vue?vue&type=script&lang=js"
export * from "./shadowTxtComment.vue?vue&type=script&lang=js"
import style0 from "./shadowTxtComment.vue?vue&type=style&index=0&id=7950ff9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7950ff9c",
  null
  
)

export default component.exports